import type React from "react";
import { IconButton, type IconButtonProps } from "@mui/material";
import { useIntl } from "react-intl";
import CloseRounded from "@mui/icons-material/CloseRounded";

export const ModalCloseButton: React.FC<IconButtonProps> = (props) => {
	const intl = useIntl();

	return (
		<IconButton
			aria-label={intl.formatMessage({ id: "modal.close", defaultMessage: "Close" })}
			size="small"
			{...props}
			sx={{
				gridArea: "close",
				...props?.sx,
			}}
		>
			<CloseRounded fontSize="large" />
		</IconButton>
	);
};
